module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [(true) ? _c('top-countdown', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "date": _vm.countdown
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('navbar-overlay', {
    staticClass: "navbar-overlay"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('top-section') : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-wrapper"
  }), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('div', {
    staticClass: "contact-info"
  }, [_c('div-container', {
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline is-flex-mobile"
  }, [_c('div', {
    staticClass: "column is-6 is-12-mobile"
  }, [_c('contact-section', {
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-12-mobile wrapper is-hidden-mobile"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-5 is-12-mobile wrapper"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline is-hidden-mobile",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-left"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "2.6em"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-12 has-text-left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', [_c('b', [_vm._v("Fundraising / Vending / Event Coordinating")])]), _vm._v(" "), _c('div', [_vm._v("\n                  Nan Lynch or Lindsey Beazley Keller • (706) 554-8100\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('b', [_vm._v("Team Registration")])]), _vm._v(" "), _c('div', [_vm._v("\n                  Elizabeth Billips • (706) 551-0729\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('b', [_vm._v("Judges Signup")])]), _vm._v(" "), _c('div', [_vm._v("\n                  Tim Lively • (706) 551-2045\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": _vm.navLocation.path,
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "float": "left",
      "margin-right": "15px"
    },
    attrs: {
      "src": require("./assets/ic_pin.svg"),
      "width": "40"
    }
  })]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Boss Hog Cook-Off")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#390e07"
    },
    attrs: {
      "href": _vm.navLocation.path,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.navLocation.title))])])])])])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('footer-main') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb9d0c2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 944
// module chunks = 1